/**
 * SplashScreen - Shown after login, fades to main content
 */

import { useState, useEffect } from 'react';
import { useTheme } from '../lib/design-system';

interface SplashScreenProps {
  onComplete: () => void;
}

export default function SplashScreen({ onComplete }: SplashScreenProps) {
  const { theme } = useTheme();
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 2000);
    const doneTimer = setTimeout(() => onComplete(), 2800);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [onComplete]);

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center transition-opacity duration-700"
      style={{
        opacity: fadeOut ? 0 : 1,
        background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.secondary} 50%, ${theme.accent} 100%)`,
      }}
    >
      {/* Mojo photo in circle */}
      <div
        className="w-[28rem] h-[28rem] md:w-[36rem] md:h-[36rem] rounded-full overflow-hidden mb-8 -mt-16"
        style={{
          boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
        }}
      >
        <img
          src="/images/mojo.jpg"
          alt="Mojo"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* App name */}
      <h1 className="text-4xl md:text-5xl font-bold text-white mb-2 tracking-tight">
        Mojo's Class
      </h1>
      <p className="text-lg text-white/70">
        Hundetraining leicht gemacht
      </p>
    </div>
  );
}
